<!--  -->
<template>
  <div class="recordSelect">
    <van-list 
    v-if="list.length"
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      :immediate-check="false"
      :offset="60"
      @load="onLoad"
    >
      <div class="recordSelect-item" v-for="(item, idx) in list" :key="idx">
        <div class="record-item-left">
          <h3>{{ item.title||'无' }}</h3>
          <span>{{ item.createTime }}</span>
        </div>
        <div class="record-item-right">
          <van-icon name="plus" color="#FF7F41" size="0.3rem" v-if="item.type === 1"/>
          <van-icon name="minus" color="#FF7F41" size="0.3rem" v-if="item.type === 2" />
          <span>{{ item.count }}</span>
        </div>
      </div>
    </van-list>
    <EmptyData v-if="!list.length" />
  </div>
</template>
  
  <script>
  import EmptyData from './emptyData.vue';
import { reqCardDrawRecord } from '@/api/collectCard/index';
export default {
  components: {
    EmptyData
  },
  data() {
    return {
      list: [],
      pageParams: {
        pageNum: 1,
        pageSize: 20,
      },
      loading: true, // 当loading为true时，转圈圈
      finished: false, // 数据是否请求结束，结束会先显示- 没有更多了 -
    };
  },
  props: {
    cardActiveId: {
      type: String,
      default: 0,
    },
  },
  computed: {},
  created() {
    this.getRecord();
  },
  mounted() {},
  methods: {
    onLoad() {
      if (this.finished) return;
      setTimeout(() => {
        this.getRecord();
        this.loading = true;
      }, 1000);
    },
    async getRecord() {
      this.$toast.loading({
        duration: 0,
        message: '',
        forbidClick: true,
      });
      const res = await reqCardDrawRecord({
        id: this.cardActiveId,
        ...this.pageParams
      });
      if (res?.code === 0 && res?.data.data) {
        this.loading = false;
        this.list = this.list.concat(res.data.data);
        // eslint-disable-next-line
        this.pageParams.pageNum++;
        // 如果没有数据，显示暂无数据
        if (this.list.length === 0 && res.data.total === 0) {}
        // 如果加载完毕，显示没有更多了
        if (this.list.length >= res.data.total) {
          this.finished = true;
        }
      }
      this.$toast.clear();
    },
  },
};
</script>
  <style lang='scss' scoped>
.recordSelect {
  width: 678px;
  margin: 0 auto;
  .recordSelect-item {
    display: flex;
    justify-content: space-between;
    align-content: center;
    background: #ffffff;
    border-radius: 14px;
    margin-bottom: 20px;
    padding: 30px;
    .record-item-left {
      h3 {
        font-weight: 500;
        font-size: 29px;
        color: #333333;
      }
      span {
        font-weight: 400;
        font-size: 22px;
        color: #999999;
      }
    }
    .record-item-right {
      display: flex;
      align-items: center;
      span {
        font-weight: 500;
        font-size: 29px;
        color: #ff7f41;
      }
    }
  }
}
</style>